/**
 * A place for inline manual mods and checks
 */
namespace appn.launchInlineManual {

    export function init(): void {
        addEvents();

        // Check if the help widget links are currently disabled
        const helpWidgetDisabled = appn.localStorage.getItem('helpWidgetDisabled');
        if (helpWidgetDisabled) {
            $('.menuitem-helpAndTuts').closest('.treeview').hide();
            console.warn('Help widget links have been disabled.');
        }
    }

    function addEvents() {
        // Hook into menu clicks for inline manual
        $('.btn-inlinemanual-menuitem').on('click', function(e) {
            e.preventDefault();

            const classes = $(this).prop('class').split(' ');
            let topicId = 0;
            for (const i of classes)
                if (i.trim().startsWith('topicid'))
                    topicId = i.split('-')[1];

            appn.launchInlineManual.launchTopic(topicId);
        });

        $('.menuitem-helpAndTuts').on('click', function(e) {
            appn.launchInlineManual.wasLoadedSuccessfully();
        });
    }

    /**
     * Checks the window object for inline manual.
     * If its not found then the help links are useless because they are specific to inline manual - so they are hidden temporarily until next logon
     * Inline manual could not be available for two reasons
     *  1. Because it failed to load due to a connection problem
     *  2. The customer has WaaS where they need to supply their own Help widget in custom scripts
     * In-case of 2 above they should use the new Side Menu Customizations to create their own links to their own help widget
     */
    export function wasLoadedSuccessfully(): boolean {
        if (window.hasOwnProperty('inline_manual_player')) {
            appn.localStorage.removeItem('helpWidgetDisabled');
            $('.menuitem-helpAndTuts').closest('.treeview').show();
            return true;
        }

        // Hide the help and tuts menu if no inline manual found - the links are useless if its not loaded
        $('.menuitem-helpAndTuts').closest('.treeview').hide();
        appn.localStorage.setItem('helpWidgetDisabled', true);
        console.warn('Cannot find inline_manual_player obj. Help widget links have been disabled.');

        return false;
    }

    /**
     * Launches a help topic
     * @param topicId
     * @param stepId
     */
    export function launchTopic(topicId: number, stepId?: number) {
        if (!appn.launchInlineManual.wasLoadedSuccessfully())
            return;

        if (!stepId) {
            (window as any).inline_manual_player.activateTopic(topicId);
            return;
        }
        (window as any).inline_manual_player.activateStep(topicId, stepId);
    }
}
